import React, { memo, useEffect, useState, useCallback } from 'react';
import chroma from 'chroma-js';
import { HeaderContent, StyledHeader, HeaderWrapper, UserAndStorage } from './Header.Styles';
import { useTheme } from '@web/theme';
import { useScroll, Navigation, ToggleButton, NavigationMobile } from '../../../ModuleApp';
import { usePage } from '../../../ModulePage';
import { StorageSize } from './StorageSize';
export var Header = memo(function (_a) {
    var defaultOpacity = _a.defaultOpacity, defaultHeight = _a.defaultHeight, maxOpacity = _a.maxOpacity, minHeight = _a.minHeight, logo = _a.logo, navigation = _a.navigation, user = _a.user;
    var theme = useTheme();
    var pageId = usePage().pageId;
    var scroll = useScroll().scroll;
    var _b = useState(defaultHeight), height = _b[0], setHeight = _b[1];
    var _c = useState(false), menuIsOpen = _c[0], setMenuIsOpen = _c[1];
    useEffect(function () {
        var h = defaultHeight;
        h = h - (scroll.top / 4);
        h = h < minHeight ? minHeight : h;
        h = h > defaultHeight ? defaultHeight : h;
        setHeight(function (prevState) { return (prevState !== h ? h : prevState); });
    }, [scroll.top]);
    useEffect(function () { return setMenuIsOpen(false); }, [pageId]);
    var toggleMenu = useCallback(function (b) { return setMenuIsOpen(b); }, []);
    return (React.createElement(HeaderWrapper, null,
        React.createElement(StyledHeader, { style: {
                height: height,
                background: chroma(theme.accent.bg).alpha(defaultOpacity + (((maxOpacity - defaultOpacity) / 100) * ((defaultHeight - height) / ((defaultHeight - minHeight) / 100)))).hex()
            } },
            React.createElement(HeaderContent, null,
                logo,
                React.createElement(Navigation, { links: navigation }),
                React.createElement(ToggleButton, { open: menuIsOpen, onClick: toggleMenu }),
                React.createElement(UserAndStorage, null,
                    user,
                    React.createElement(StorageSize, null)))),
        React.createElement(NavigationMobile, { links: navigation, isOpen: menuIsOpen })));
});
